import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import AnimatedCounter from "@/components/AnimatedCounter";

const stats = [
  { end: 50, suffix: "+", label: "Active Members" },
  { end: 6, suffix: "", label: "Focus Areas" },
  { end: 15, suffix: "+", label: "Events / Year" },
  { end: 20, suffix: "+", label: "Holdings" },
];

const AboutHero = () => {
  return (
    <section className="py-24 md:py-32 bg-paper text-navy-dark">
      <div className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 lg:gap-24 items-start">
        {/* Left: sticky mission copy */}
        <div className="lg:w-1/2 lg:sticky lg:top-32">
          <span className="text-steel uppercase tracking-[0.3em] text-[10px] font-bold mb-6 block">
            Our Mission
          </span>
          <h2 className="font-serif text-4xl lg:text-5xl leading-tight mb-8 text-navy-dark">
            Empowering the next generation of analysts.
          </h2>
          <p className="text-navy text-lg leading-relaxed mb-10">
            JIC is more than a club — it&rsquo;s an accelerator for finance-focused
            students at JIBS. We provide the tools, the network, and the capital
            to transform potential into professional excellence.
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-3 text-steel font-bold text-[11px] uppercase tracking-[0.25em] border-b-2 border-steel pb-1 hover:gap-4 transition-all"
          >
            Learn more about us
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        {/* Right: 2×2 stat grid */}
        <div className="lg:w-1/2 grid grid-cols-1 sm:grid-cols-2 gap-px bg-navy-dark/10 border border-navy-dark/10 w-full">
          {stats.map((s) => (
            <div key={s.label} className="bg-paper p-10 lg:p-12">
              <AnimatedCounter
                end={s.end}
                suffix={s.suffix}
                className="font-serif text-5xl font-bold text-navy-dark mb-3 block"
              />
              <div className="text-[10px] uppercase tracking-widest font-bold text-steel">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
